// getters
const restaurantReports = state => state.restaurantReports

export default {
  restaurantReports
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/reports/getters.js